export const getPageEventsReportTableHeaders = () =>
	Object.freeze(['No', 'Variant', 'Source Event Count', 'Target Event Count']);
